import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AlertService, AlertType } from 'src/app/core/services/alert.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { MemberService } from 'src/app/core/services/member.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-fan-base-callback',
  standalone: true,
  imports: [],
  template: ''
})
export class FanBaseCallbackComponent implements OnInit {

  private _destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private memberService: MemberService,
    private authService: AuthService,
    private alertService: AlertService
  ) {
    const currentUserValue = this.userService.currentUserValue
      ? Object.keys(this.userService.currentUserValue)
      : null;

    if (currentUserValue?.length) {
      this.router.navigate([this.userService.currentUserValue?.isDependent ? '/dashboard-dependente' : '/dashboard']);
    }
  }

  ngOnInit(): void {
    const code = this.route.snapshot.queryParams['code'];

    if (code) {
      this.memberService.postFanBaseMember(code).subscribe({
        next: (userId) => {
          this.loginMemberByBackoffice(userId);
        },
        error: (error) => {
          this.alertService.showAlert(
            AlertType.WARNING,
            error.error.message || 'Erro ao processar login Fan Base.'
          );
          this.router.navigate(['/']);
        }
      });
    } else {
      this.alertService.showAlert(AlertType.WARNING, 'Erro ao processar login Fan Base.');
      this.router.navigate(['/']);
    }
  }

  loginMemberByBackoffice(userId: string) {
    localStorage.removeItem('isSecondaryPlan');
    localStorage.removeItem('secondaryPlanDetail');
    this.authService
      .loginMemberByBackoffice(userId)
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        error: (error) => {
          this.alertService.showAlert(
            AlertType.DANGER,
            error.error.message || 'Erro ao fazer login automático.'
          );
        },
      });
  }

}
